import React from "react";
import "../entity-calander.scss";
import { Card } from "primereact/card";
import { Tag } from "primereact/tag";
import PropTypes from "prop-types";
import ReactCountryFlag from "react-country-flag";
import { format } from "date-fns";

const EventList = ({
  events,
  entity,
  handleSelectEvent,
  handleCloseEventDetailCalander,
}) => {
  const formatMilestoneDate = (dateString) => {
    if (!dateString) return "-";
    const dateObj =
      dateString instanceof Date ? dateString : new Date(dateString);
    // Check if date is Invalid Date
    if (isNaN(dateObj.getTime())) return "-";
    return format(dateObj, "MMMM do, yyyy");
  };
  return (
    <div className="event-list-container">
      <div className="header-container">
        <h2 className="header-title"> Upcoming Events</h2>
        <span className="close-sidebar">
          <i
            className="pi pi-times"
            onClick={handleCloseEventDetailCalander}
          ></i>
        </span>
      </div>

      <div className="content-container">
        <p className="date">Date: {formatMilestoneDate(events[0]["start"])}</p>
        {events?.map(
          ({
            title,
            subTitle,
            label,
            type,
            country,
            start,
            oneliner,
            id,
            status,
            end,
            color,
            backgroundColor,
            process,
            due_date_utc,
            processData,
          }) => (
            <Card
              key={id}
              style={{
                borderInlineStartColor: color,
                backgroundColor: backgroundColor,
              }}
              onClick={() => {
                handleSelectEvent(
                  {
                    title,
                    subTitle,
                    label,
                    type,
                    country,
                    start,
                    oneliner,
                    id,
                    status,
                    end,
                    color,
                    backgroundColor,
                    process,
                    due_date_utc,
                    processData,
                  },
                  true,
                );
              }}
            >
              <p className="event-service-name">
                {type === "EVENT" ? label : "Holiday"}
              </p>
              <p className="event-name-status">
                {title} {type === "EVENT" && `(${status?.name})`}
              </p>
              {type === "EVENT" ? (
                <p className="event-process-name"> {processData?.name} </p>
              ) : (
                <div className={"holiday-info"}>
                  <ReactCountryFlag
                    countryCode={country}
                    svg
                    className={"country_flag"}
                  />
                  {subTitle}
                </div>
              )}
              {type === "EVENT" && (
                <p className="event-due-date">
                  Deadline: {formatMilestoneDate(start)}
                </p>
              )}
            </Card>
          ),
        )}
      </div>
    </div>
  );
};

EventList.propTypes = {
  events: PropTypes.array,
  entity: PropTypes.object,
  handleCloseEventDetailCalander: PropTypes.func,
  handleSelectEvent: PropTypes.func,
};

export default EventList;
